import { ThemedButton } from "Components/Themes/components/ThemedButton";
import styled from "styled-components";

export const ReadMoreContainer = styled.div`
  margin: 16px 0;
`;

export const StyledButton = styled(ThemedButton)`
  display: flex;
  min-height: 0;
  padding: 0;

  span {
    display: flex;
  }

  &:active,
  &:focus,
  &:hover {
    background: none;
  }
`;
